export default __webpack_public_path__ + "images/cart-qt4CRE8.svg";